/**
 * Create by zxp on 2019/10/24
 *
 */
// -----------有关全局加载的vuex
const state = {
  loadingList: []
}
const mutations = {
  // -----------请求一个接口push一个对象
  PUSH_LOADING (state, toastMsg) {
    state.loadingList.push({text: toastMsg || 'loading...'})
  },
  // -----------请求的接口响应后从数组中shift移除掉
  SHITF_LOADING (state) {
    state.loadingList.shift()
  }
}
const getters = {
  isLoading: state => state.loadingList.length > 0,
  loadingText: state => state.loadingList.length > 0 ? state.loadingList[0].text : null
}

const actions = {
  openLoading (contaxt, toastMsg) {
    contaxt.commit('PUSH_LOADING', toastMsg)
  },
  closeLoading (contaxt) {
    contaxt.commit('SHITF_LOADING')
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/loading.js